module.exports = __webpack_public_path__ + "static/media/buddy.1e6e1e29.svg";